var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center",attrs:{"width":"60px"}},[_c('v-select',{staticClass:"py-2 px-0",staticStyle:{"max-width":"50px","font-size":"15px"},attrs:{"items":_vm.sizes,"item-value":"key","item-text":"name","label":"","dense":"","hide-details":"","menu-props":{
      bottom: true,
      offsetY: true,
      transition: 'scale-transition',
    },"single-line":""},on:{"change":_vm.changed},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }